import React from 'react'
import "../../scss/home.scss";
import "../../scss/button.scss";
import Navbar from '../Navbar';
import Order from './order';
import { Link } from 'react-router-dom';

const Home = () => {

    return (
        <div>
            <Navbar />
            <Order />
            <Link to='/report' className='btn-search-view'>
                <button className='btn-search'>Report</button>
            </Link>
        </div>
    )
}

export default Home
